import { TellAFriendCSSStyle } from './tellafriendcss';
import { UIComponentViewImpl } from '../../../toolkit/uicomponentview';
import { UIComponentState } from '../../../toolkit/uicomponent';
import * as React from 'react';
import { TellAFriendComponentProps, TellAFriendComponentHandler } from './tellafriendcomponent';
import { ToneDetailsPopupComponent, ToneOptionsType } from '../tonedetailspopup/tonedetailspopupcomponent';
import { Strings } from '../../../../utils/resources/strings';
import { ButtonComponent } from '../../../toolkit/button/buttoncomponent';
import { FloatingTextComponent } from '../../../toolkit/floatingtext/floatingtextcomponent';
import { ReferToneDto, ReferToneDtoImpl } from '../../../../core/dto/refertone/refertonedto';
import { MsisdnFloatingTextComponent } from '../../../toolkit/floatingtext/msisdnfloatingtext/msisdnfloatingtextcomponent';
import { MSISDNValidation } from '../../../toolkit/msisdnvalidation/msisdnvalidation';
import { ConfirmRequestConfirmButtonCSSStyleImpl } from '../confirmrequest/confirmrequestconfirmbuttoncss';
import { LoaderWrapperComponent } from '../loaderwrappercomponent';
import { LoaderComponent } from '../../../toolkit/loader/loadercomponent';
import './tellafriend-style.css';

export class TellAFriendViewImpl extends UIComponentViewImpl<ReferToneDto>
{
    private contactNumber: FloatingTextComponent;
    // private contactNumber2: FloatingTextComponent;
    // private contactNumber3: FloatingTextComponent;
    private loaderWrapperComponent:LoaderWrapperComponent;

    bindHandlers()
    {   
        this.onConfirmClick = this.onConfirmClick.bind(this);
        this.onKeyPressEvent = this.onKeyPressEvent.bind(this);
        document.addEventListener("keydown",this.onKeyPressEvent);
    }

    draw(props: TellAFriendComponentProps, state: UIComponentState, cssStyle: TellAFriendCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <div style={cssStyle.getWrapperCSSStyle()}>
                 {
                    this.getWebView(props, state, cssStyle)
                 }
                <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>
            </div>
        );
    }

    getWebView(props: TellAFriendComponentProps, state: UIComponentState, cssStyle: TellAFriendCSSStyle)
    {
        return (
            <>
             <ToneDetailsPopupComponent onCloseClick={props.closePopup} headerTitle={props.context.getResources().getString(Strings.tellafriend)} toneDto={props.toneDto} context={props.context}/>
               <div id="tellafriend-main-div">
                    <label id="tellafriend-label">
                        {this.getContext().getResources().getString(Strings.tell_a_friend_msg)}
                    </label>
               </div>

               <div style={cssStyle.getContactNumberCSSStyle()}>
                    <MsisdnFloatingTextComponent maxLength={this.getUIProps().context.getResources().getString(Strings.numberMaxLength)} ref={(item: any) => {this.contactNumber = item;}} id={"#contactNumber"} value={""} inputType={"number"} isRequired={true} placeholder={this.getContext().getResources().getString(Strings.friend_number)} context={props.context} emptyErrorMsg={this.getContext().getResources().getString(Strings.invalid_friend_number)}/>
               </div>
               {/* <div style={cssStyle.getContactNumberCSSStyle()}>
                    <MsisdnFloatingTextComponent maxLength={this.getUIProps().context.getResources().getString(Strings.numberMaxLength)} ref={(item: any) => {this.contactNumber2 = item;}} id={"#contactNumber"} value={""} inputType={"number"} isRequired={true} placeholder={this.getContext().getResources().getString(Strings.friend_number)} context={props.context} emptyErrorMsg={this.getContext().getResources().getString(Strings.invalid_friend_number)}/>
               </div>
               <div style={cssStyle.getContactNumberCSSStyle()}>
                    <MsisdnFloatingTextComponent maxLength={this.getUIProps().context.getResources().getString(Strings.numberMaxLength)} ref={(item: any) => {this.contactNumber3 = item;}} id={"#contactNumber"} value={""} inputType={"number"} isRequired={true} placeholder={this.getContext().getResources().getString(Strings.friend_number)} context={props.context} emptyErrorMsg={this.getContext().getResources().getString(Strings.invalid_friend_number)}/>
               </div> */}
               {/* <div style={{width:'100%',height:'40px',lineHeight:'40px',color:'#003187',textAlign:'center', marginTop:'25px',}}>
                  <label style={{fontWeight:300}}>
                      {this.getContext().getResources().getString(Strings.tell_a_friend_add_number)}
                  </label>
               </div> */}
               <div style={cssStyle.getConfirmButtonCSSStyle()}>
                    <ButtonComponent onClick={this.onConfirmClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.confirm)}/>
                </div>
            </>
        );
    }

    // getMobileView(props: TellAFriendComponentProps, state: UIComponentState, cssStyle: TellAFriendCSSStyle)
    // {
    //     return (
    //         <>
    //          <ToneDetailsPopupComponent onCloseClick={props.closePopup} headerTitle={props.context.getResources().getString(Strings.tellafriend)} toneDto={props.toneDto} context={props.context}/>
    //            <div  style={{width:'89%',height:'40px',marginTop:'20px',marginLeft:'25px',marginRight:'25px', lineHeight:'20px',}}>
    //                 <label  style={{}}>
    //                     {this.getContext().getResources().getString(Strings.tell_a_friend_msg)}
    //                 </label>
    //            </div>

    //            <div style={cssStyle.getContactNumberCSSStyle()}>
    //                 <MsisdnFloatingTextComponent maxLength={this.getUIProps().context.getResources().getString(Strings.numberMaxLength)} ref={(item: any) => {this.contactNumber = item;}} id={"#contactNumber"} value={""} inputType={"number"} isRequired={true} placeholder={this.getContext().getResources().getString(Strings.friend_number)} context={props.context} emptyErrorMsg={this.getContext().getResources().getString(Strings.invalid_friend_number)}/>
    //            </div>
    //            <div style={cssStyle.getContactNumberCSSStyle()}>
    //                 <MsisdnFloatingTextComponent maxLength={this.getUIProps().context.getResources().getString(Strings.numberMaxLength)} ref={(item: any) => {this.contactNumber2 = item;}} id={"#contactNumber"} value={""} inputType={"number"} isRequired={true} placeholder={this.getContext().getResources().getString(Strings.friend_number)} context={props.context} emptyErrorMsg={this.getContext().getResources().getString(Strings.invalid_friend_number)}/>
    //            </div>
    //            <div style={cssStyle.getContactNumberCSSStyle()}>
    //                 <MsisdnFloatingTextComponent maxLength={this.getUIProps().context.getResources().getString(Strings.numberMaxLength)} ref={(item: any) => {this.contactNumber3 = item;}} id={"#contactNumber"} value={""} inputType={"number"} isRequired={true} placeholder={this.getContext().getResources().getString(Strings.friend_number)} context={props.context} emptyErrorMsg={this.getContext().getResources().getString(Strings.invalid_friend_number)}/>
    //            </div>
    //            {/* <div style={{width:'100%',height:'40px',lineHeight:'40px',color:'#003187',textAlign:'center', marginTop:'25px',}}>
    //               <label style={{fontWeight:300}}>
    //                   {this.getContext().getResources().getString(Strings.tell_a_friend_add_number)}
    //               </label>
    //            </div> */}
    //            <div style={cssStyle.getConfirmButtonCSSStyle()}>
    //                 <ButtonComponent onClick={this.onConfirmClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.confirm)}/>
    //             </div>
    //         </>
    //     );
    // }

    showLoader()
    {
       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }
    validate(): boolean
    {
        // if(this.contactNumber.validate())
        // {
        //     let numberMinLength = +this.getUIProps().context.getResources().getString(Strings.numberMinLength);
        //     let numbermaxLength = +this.getUIProps().context.getResources().getString(Strings.numberMaxLength);

        //     if(this.contactNumber.getData().length < numberMinLength 
        //                     || this.contactNumber.getData().length > numbermaxLength)
        //     {
        //         this.contactNumber.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.invalidLength));
        //         return false;
        //     }
            
        //     return true;
        // }
        // return false;

        if(this.contactNumber.validate())
        {
            let msisdn = MSISDNValidation.validateCCMsisdn(
                this.getUIProps().context.getResources().getString(Strings.countrycode), this.contactNumber.getData());
          
            let numberMinLength = this.getUIProps().context.getResources().getString(Strings.numberMinLength);
            let numbermaxLength = this.getUIProps().context.getResources().getString(Strings.numberMaxLength);

           
            if(!MSISDNValidation.validateLengthMsisdn(msisdn, numberMinLength, numbermaxLength))
            {
                this.contactNumber.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.invalidLength));
                return false;   
            }
            
           
            else if(this.getContext().getUserContext().getMsisdn() === this.contactNumber.getData())
            {
                 this.contactNumber.setErrorMessage(this.getContext().getResources().getString(Strings.number_cannot_be_same_as_the_logged_in_number));
                 return false;
            }
            return true;        
        } 
        
        return false;    
    }

    getData(): ReferToneDto
    {
        let toneDto = (this.getUIProps() as TellAFriendComponentProps).toneDto;

        let request = new ReferToneDtoImpl();
        request.setToneId((this.getUIProps() as TellAFriendComponentProps).toneOptionsType 
        === ToneOptionsType.TONE ? toneDto.getId(): toneDto.getContentId().split("|")[0]);
        request.setToneName(toneDto.getToneName());
        request.setAPartyMsisdn(this.getUIProps().context.getUserContext().getMsisdn());
        request.setLanguage(this.getUIProps().context.getUserContext().getLanguage());
        // request.setMsisdnList(['{"bPartyMsisdn":"' +  
        // this.contactNumber.getData()+ '"}']);
        //  '{"bPartyMsisdn":"' + 
        // this.contactNumber3.getData()+ '"}']);
        request.setMsisdnList([this.contactNumber.getData()]);
//for subscriber validate setMsisdnlist().index[0];
        return request;
    }

    onKeyPressEvent(event:any):void
    {
        console.log("key code", event.code+event.keyCode);
          if(event.code === "Enter")
          {
              this.onConfirmClick();
          }
    }
    private onConfirmClick()
    {
        (this.getUIComponentHandler() as TellAFriendComponentHandler).onConfirmClick();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/tellafriend/tellafriendview.tsx